import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchJobsByKeywords } from "./jobSearchByKeywordAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchJobsByKeywordsAsync = createAsyncThunk(
  "JobsByKeywords/fetch",
  async ({ experience, locations, skills, titles, company }, { rejectWithValue }) => {
    try {
      const data = await fetchJobsByKeywords(experience, locations, skills, titles, company);

      if (!data || !data.response || !data.response.data) {
        throw new Error("Invalid response structure");
      }
      // console.log("slice", data);
      // return data.response.data;

      return {
        jobs: data.response.data,  // The array of job data
        totalJobs: data.response.total,  
      };
    } catch (error) {
      console.error("Error in fetchJobsByKeywordsAsync:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "An unknown error occurred"
      );
    }
  }
);

const JobsByKeywordsSlice = createSlice({
  name: "JobsByKeywords",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobsByKeywordsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobsByKeywordsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("data", action.payload);
        state.error = null;
      })
      .addCase(fetchJobsByKeywordsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const selectJobsByKeywords = (state) => state.jobsByKeywords.data.jobs;
export const selectJobsByKeywordsTotal = (state) => state.jobsByKeywords.data.totalJobs;
// export const selectJobsByKeywords = (state) => state.jobsByKeywords.data;

export default JobsByKeywordsSlice.reducer;
